import React, { useState } from 'react';
import './TechnologyCapabilities.css';
const capabilities = [
  { id: 'platform', title: 'Business Platforms', detail: 'CRM, Google Workspace, the Microsoft ecosystem and business platforms.', step: 1, action: 'Use the platform you already have', tool: 'Existing customer record', reason: 'When the work needs shared records and clear ownership, configure a suitable existing platform before buying another tool.' },
  { id: 'automation', title: 'Automation & Integration', detail: 'Workflow automation, APIs and system integrations.', step: 3, action: 'Connect repeatable work', tool: 'Follow-up reminder', reason: 'When teams repeatedly copy data or chase updates, connect the relevant systems and automate agreed steps, with an owner for exceptions.' },
  { id: 'ai', title: 'AI & Intelligence', detail: 'OpenAI, Claude, Gemini and models suited to the task.', step: 2, action: 'Support work that needs judgement', tool: 'AI-assisted draft · person reviews', reason: 'Use AI for drafting, retrieval or analysis when it can help the team. Define the source material, review criteria and human approval before use.' },
  { id: 'custom', title: 'Custom Solutions', detail: 'Web applications, internal tools, portals and dashboards.', step: 4, action: 'Create a view that fits the work', tool: 'Tailored owner view', reason: 'Only when existing tools cannot provide the view or workflow the business needs, build a tailored interface around that requirement.' }
];
const TechnologyCapabilities = () => {
  const [selected, setSelected] = useState('platform');
  const capability = capabilities.find(item => item.id === selected);
  return (
    <section className="technology-capabilities section" id="technology" aria-labelledby="technology-title">
      <div className="container technology-layout">
        <div className="technology-heading">
          <span className="label">The right tools, in the right places</span>
          <h2 id="technology-title">Technology chosen around the business.<br /><em>Not the other way around.</em></h2>
          <p>Keep what works. Add a capability only when it solves a defined need.</p>
        </div>
        <div className="technology-story">
          <div className="technology-groups" aria-label="Explore technology choices">
            {capabilities.map(item => (
              <button type="button" className="technology-group" key={item.id} aria-pressed={selected === item.id} aria-controls="technology-explanation" onClick={() => setSelected(item.id)}>
                <span className="technology-choice-title">{item.title}<span aria-hidden="true">{selected === item.id ? '−' : '+'}</span></span>
                <span className="technology-choice-detail">{item.detail}</span>
              </button>
            ))}
          </div>
          <div className="technology-explanation" id="technology-explanation" aria-live="polite" aria-atomic="true">
            <div key={selected} className="technology-explanation-inner">
              <span className="technology-tool-label">When this is useful</span>
              <h3>{capability.action}</h3>
              <p>{capability.reason}</p>
            </div>
          </div>
        </div>
        <p className="technology-governance">
          Owleyes is vendor-neutral. We select technology based on the business requirement. Where specialist engineering is required, implementation can be delivered with specialist technology partners under Owleyes solution governance.
        </p>
      </div>
    </section>
  );
};
export default TechnologyCapabilities;
